import Swiper from 'swiper';
import breakpoints from 'breakpoints';

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = name + '=' + value + ';' + expires + ';path=/';
}

function addProductToRecentlyViewed(productHandle) {
  let recentlyViewed = getCookie('recently_viewed')
    ? JSON.parse(getCookie('recently_viewed'))
    : [];

  if (!recentlyViewed.includes(productHandle)) {
    recentlyViewed.push(productHandle);
  }

  if (recentlyViewed.length > 6) {
    recentlyViewed.shift();
  }

  setCookie('recently_viewed', JSON.stringify(recentlyViewed), 30);
}

function displayRecentlyViewed(callback) {
  const recentlyViewed = getCookie('recently_viewed')
    ? JSON.parse(getCookie('recently_viewed'))
    : [];

  const section = document.querySelector('.recently-viewed__section');

  if (recentlyViewed.length > 0) {
    section.style.display = 'block';
    const container = document.querySelector(
      '.recently-viewed__container .recently-viewed__list-container',
    );
    container.innerHTML = '';

    recentlyViewed.forEach((handle) => {
      fetch(`/products/${handle}.js`)
        .then((response) => response.json())
        .then((product) => {
          const soldOut = !product.variants.some(
            (variant) => variant.available,
          );
          const firstVariant = product.variants[0];
          const imageChange =
            product.images.length > 1 ? 'data-img-change' : '';

          const mediaHTML = product.images
            .slice(0, 2)
            .map((image, index) => {
              let imageClass;
              if (index == 0) {
                imageClass = 'default';
              } else {
                imageClass = 'hover';
              }
              return `
                  <div class="media__container product-tile__images__img--${imageClass}">
                    <img
                      src="${image}"
                      alt="${product.title}"
                      class="media"
                    />
                  </div>
                `;
            })
            .join('');

          const productHTML = `
            <div class="product-tile__container swiper-slide" ${imageChange}>
              <a href="${product.url}" class="product-tile__gallery">
                <div class="product-tile__media">
                  ${mediaHTML}
                </div>
              </a>
              <div class="product-tile__info">
                ${product.vendor ? `<p class="product-tile__vendor">${product.vendor}</p>` : ''}
                <a href="${product.url}" class="product-tile__title">
                  <p>${product.title}</p>
                </a>
                ${
                  !soldOut
                    ? `
                      <div class="product-tile__price">
                        ${firstVariant.compare_at_price ? `<del>${(firstVariant.compare_at_price / 100).toFixed(2)}</del>` : ''}
                        <span>${(firstVariant.price / 100).toFixed(2)}</span>
                      </div>
                    `
                    : '<div class="product-tile__sold-out">Sold Out</div>'
                }
              </div>
            </div>
          `;
          container.insertAdjacentHTML('beforeend', productHTML);
        });
    });
    callback();
  } else {
    section.style.display = 'none';
  }
}

function startRecentlyViewdCarousel() {
  new Swiper('.recently-viewed__container', {
    loop: true,
    slidesPerView: 1.5,
    spaceBetween: 4,
    breakpoints: {
      [parseInt(breakpoints.lg.replace('px', ''))]: {
        slidesPerView: 6,
      },
    },
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const productContainer = document.querySelector('.product-page__section');
  if (productContainer) {
    const url = window.location.pathname;
    const productHandle = url.split('/').pop();

    if (productHandle) {
      addProductToRecentlyViewed(productHandle);
    }
  }

  displayRecentlyViewed(startRecentlyViewdCarousel);
});
